import { Brain, BarChart3, ShieldAlert, Mic, Bell, Network } from 'lucide-react';

const FEATS = [
  { icon: Brain,       n: '01', title: 'Influence Graph',      desc: 'Every covered company has a live graph of suppliers, customers, competitors, regulators, and macro signals. Agents subscribe to graph nodes — not keyword searches.' },
  { icon: BarChart3,   n: '02', title: 'Projection Engine',    desc: 'Four period-final targets per stock, every day. Each closes with a public Hit / Beat / Miss verdict and a causal explanation — no hiding.' },
  { icon: ShieldAlert, n: '03', title: 'Devil\'s Advocate',    desc: 'A dedicated agent argues the opposing case, surfaces hidden fragility, and challenges every bull thesis before it goes to press.' },
  { icon: Network,     n: '04', title: 'Specialist Agents',    desc: '15 specialist agents cover fundamentals, guidance, demand, pricing, inventory, supply chain, geopolitics, valuation, and technical signals.' },
  { icon: Mic,         n: '05', title: 'Audio Briefing',       desc: 'Every report ships as a notebook-style podcast — two hosts, sourced claims, projection outcomes. 8–12 minutes. Ready before market open.' },
  { icon: Bell,        n: '06', title: 'Intraday Alerts',      desc: 'Premium intraday checks every 15–60 minutes. Alerts fire only on material changes — earnings beats, analyst moves, supply-chain shocks.' },
];

export default function Features() {
  return (
    <section className="section" id="features">
      <div className="wrap">
        <div className="sec-tag"><Brain size={13} />Platform</div>
        <h2>Built different.<br /><em>Designed for accountability.</em></h2>
        <p className="section-lead">
          Every feature exists to answer one question: did the AI's analysis hold up against reality?
        </p>
        <div className="feat-grid">
          {FEATS.map(f => (
            <div key={f.n} className="feat-card">
              <div className="feat-icon"><f.icon size={20} /></div>
              <div className="feat-n">{f.n}</div>
              <div className="feat-title">{f.title}</div>
              <div className="feat-desc">{f.desc}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
